/**
 * @generated SignedSource<<2fab809459faed81b3f9fdc083b806ee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type EntityWithPositionInput = {
  id: string;
  position?: number | null;
};
export type MediaEditorSortMutation$variables = {
  mediableId: string;
  positions: ReadonlyArray<EntityWithPositionInput>;
};
export type MediaEditorSortMutation$data = {
  readonly updateMediaPositions: {
    readonly id: string;
  };
};
export type MediaEditorSortMutation = {
  response: MediaEditorSortMutation$data;
  variables: MediaEditorSortMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "mediableId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "positions"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "mediableId",
    "variableName": "mediableId"
  },
  {
    "kind": "Variable",
    "name": "positions",
    "variableName": "positions"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MediaEditorSortMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateMediaPositions",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MediaEditorSortMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateMediaPositions",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "87f13605987044aeb8e6517b1e81b76b",
    "id": null,
    "metadata": {},
    "name": "MediaEditorSortMutation",
    "operationKind": "mutation",
    "text": "mutation MediaEditorSortMutation(\n  $mediableId: ID!\n  $positions: [EntityWithPositionInput!]!\n) {\n  updateMediaPositions(mediableId: $mediableId, positions: $positions) {\n    __typename\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "78e73a35e7af477f56b78419c030714a";

export default node;
